"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTotalOrderValue = void 0;
const getOrderLineTotal_1 = require("./getOrderLineTotal");
const getTotalOrderValue = (order, date) => {
    if (!order)
        return 0;
    if (!order.order_lines)
        return 0;
    return order.order_lines.reduce((acc, cur) => {
        return acc + (0, getOrderLineTotal_1.getOrderLineTotal)(cur, date);
    }, 0);
};
exports.getTotalOrderValue = getTotalOrderValue;
